define.alias("shared/components/shared/creator-profile-modal", "calendar/components/shared/creator-profile-modal");